import React from 'react';
import ActionButton from '../../ActionButton';
import { Grid, Typography } from '@mui/material';
import { TranslationKeys } from '../../../translations';

type FileUploadIconProps = {
  message: string;
  disabled?: boolean;
};

export const FileUploadIcon = ({ disabled = false, message }: FileUploadIconProps) => {
  return (
    <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center' }}>
      <Grid item xs={12}>
        <ActionButton messageId={TranslationKeys.button_upload} variant={'outlined'} disabled={disabled} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant={'caption'}>{message}</Typography>
      </Grid>
    </Grid>
  );
};

export const FileUploadIconContext = React.createContext<FileUploadIconProps>({ message: '', disabled: false });

export const DropzoneIcon = () => {
  const { message, disabled } = React.useContext(FileUploadIconContext);
  return <FileUploadIcon message={message} disabled={disabled} />;
};
